import { Portal } from '@chakra-ui/react';
import ProfileImagePreview from './BettieProfileImagePreview';
import ProfileImageCrop from './BettieProfileImageCrop';

export type ImageStep = 'idle' | 'crop' | 'preview';

interface BettieProfileImageOverlayProps {
  imageStep: ImageStep;
  selectedImageForCrop: string | null;
  previewImage: string | null;
  onCropComplete: (croppedImageUrl: string) => void;
  onBackFromCrop: () => void;
  onPreviewBack: () => void;
  onPreviewConfirm: () => void;
}

const BettieProfileImageOverlay = ({
  imageStep,
  selectedImageForCrop,
  previewImage,
  onCropComplete,
  onBackFromCrop,
  onPreviewBack,
  onPreviewConfirm
}: BettieProfileImageOverlayProps) => {
  if (imageStep === 'crop' && selectedImageForCrop) {
    return (
      <Portal>
        <div className="fixed inset-0 z-[10000]">
          <ProfileImageCrop
            imageSrc={selectedImageForCrop}
            onCropComplete={onCropComplete}
            onBack={onBackFromCrop}
          />
        </div>
      </Portal>
    );
  }
  if (imageStep === 'preview' && previewImage) {
    return (
      <Portal>
        <div className="fixed inset-0 z-[10000]">
          <ProfileImagePreview
            bettieProfileImage={previewImage}
            previewObjectUrl={null}
            clearBettieProfileImage={onPreviewBack}
            onConfirm={onPreviewConfirm}
            showRecommendToggle={false}
          />
        </div>
      </Portal>
    );
  }
  return null;
};

export default BettieProfileImageOverlay;
